
export const state = {
 userroles:[],
 rolemodules:[],
 moduleId:[],
 modulePermissions: [],
 moduleName:[]
}

export default state


// WEBPACK FOOTER //
// ./src/vuex/modules/userroles/state.js